import React, { useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const CkEditor = ({ value, onChange, editorRef }) => {
  useEffect(() => {
    const removeBranding = () => {
      document.querySelectorAll('.ck-powered-by, [class*="powered-by"]').forEach((el) => {
        el.remove();
      });
    };

    const observer = new MutationObserver(removeBranding);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="custom-ckeditor-wrapper">
      <style>{`
        .custom-ckeditor-wrapper .ck-powered-by,
        .custom-ckeditor-wrapper [class*="powered-by"],
        .custom-ckeditor-wrapper .ck.ck-reset.ck-powered-by {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          height: 0 !important;
          pointer-events: none !important;
        }
      `}</style>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
        onReady={(editor) => {
          editor.ui.view.editable.element.style.minHeight = "160px";
          if (editorRef) {
            editorRef.current = editor;
          }

          const editingContainer = editor.ui.view.element;
          if (editingContainer) {
            editingContainer.querySelectorAll('[class*="powered-by"]').forEach((el) => el.remove());
          }
        }}
      />
    </div>
  );
};

export default CkEditor;
